import React from "react";
import styled from "styled-components";
import { TitleSection } from "../styles/globalStyles";
import Form from "../components/Form";
import Vasco from "../components/Vasco";
import linkedinLogo from "../assets/images/linkedinLogo.png"

const Contact = () => {
  return (
    <Section id="contact">
      <TitleSection>Contact</TitleSection>
      <div className="container">
        <div className="text-contact">
          <p>
            J’aime les nouvelles expériences et les challenges.
            <br />
            N’hésitez pas à me contacter si vous avez un projet à
            réaliser ou tout simplement pour faire connaissance.
          </p>

        </div>
        <a href="https://www.linkedin.com/in/vasco-barreiros/" target="_blank" className="icons">
          <img src={linkedinLogo} alt="logo linkedin" width={300} />
        </a>
        <Form />
      </div>

      <Vasco />
    </Section>
  );
};

const Section = styled.section`
  position: relative;
  font-family: "Poppins","sans-serif";
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 100vh;
  overflow: hidden;
  
  .icons {
    margin-top: 20px;
    display: none;
    visibility: hidden;
  }

  .icons > img {
    margin:0;
    padding:0;
    width: 30px;
  }

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  p {
    font-size: clamp(14px, 5vw, 22px);
    overflow: hidden;
    display: table-cell;
  }

  .text-contact {
    width: 80%;
    display: grid;
    place-items: center;
    display: table;
    margin-top: 20px;
  }
  @media (max-width: 768px) {
    .icons {
      display: block;  
      visibility: visible;
    }
  }
`;

export default Contact;
